<div [hidden]="!CurrentScreenOption.IsVisible" class="CPQComponent">
  <label htmlFor="{{CurrentScreenOption.ID}}" [ngClass]="{'invalid' : !CurrentScreenOption.IsValid}">{{CurrentScreenOption.Caption + " " + CurrentScreenOption.Description}}</label>
  <input type="checkbox"
         [checked]="CurrentScreenOption.Value == 'True'"
         id="{{CurrentScreenOption.ID}}"
         name="{{CurrentScreenOption.ID}}"
         value="{{CurrentScreenOption.Value}}"
         [disabled]="!CurrentScreenOption.IsEnabled"
         [required]="CurrentScreenOption.IsRequired"
         (onclick)="onCheckChange($event,CurrentScreenOption.AutoContinueMode)"
         (change)="onCheckChange($event,CurrentScreenOption.AutoContinueMode)"/>
</div>
